import {
  type CreateEmailLabelInput,
  type CreateInboxLabelMutation,
  type FetchResult,
  type MutationResult,
  useCreateInboxLabelMutation,
} from "@qw/graphql";
import { useToast } from "@qw/ui";
import { useCallback } from "react";

export const useCreateLabel = (): [
  (input: CreateEmailLabelInput) => Promise<FetchResult<CreateInboxLabelMutation>>,
  MutationResult<CreateInboxLabelMutation>,
] => {
  const { toast } = useToast();
  const [createLabelMutation, result] = useCreateInboxLabelMutation();

  const createLabel = useCallback(
    (input: CreateEmailLabelInput) =>
      createLabelMutation({
        variables: { input },
        onCompleted: (data) => {
          if (!data?.createInboxLabel) {
            throw new Error("Failed to create label");
          }

          toast({
            title: "Label created",
            description: "Your label has been created successfully",
          });
        },
        onError: (error) => {
          toast({
            title: "Failed to create label",
            description: error instanceof Error ? error.message : "An unexpected error occurred",
            variant: "destructive",
          });
        },
        refetchQueries: ["InboxLabels"],
      }),
    [createLabelMutation, toast]
  );

  return [createLabel, result];
};
